(() => {
  if (window.CFACardOptions) return;
  window.CFACardOptions = true;

  document.addEventListener('click', event => {
    const option = event.target.closest('[data-cfa-card-option]');
    if (!option) return;
    const card = option.closest('product-card');
    if (!card) return;

    option.closest('[data-cfa-card-options]').querySelectorAll('[data-cfa-card-option]').forEach(button => {
      button.setAttribute('aria-pressed', String(button === option));
    });

    const variantId = option.dataset.variantId;
    const handle = card.getAttribute('handle');
    card.querySelectorAll('.product-card__media, .product-title').forEach(link => {
      if (link.tagName === 'A') link.href = `/products/${handle}?variant=${variantId}`;
    });
    const quickBuy = card.querySelector('quick-buy-modal');
    if (quickBuy) quickBuy.setAttribute('handle', `${handle}?variant=${variantId}`);

    const status = option.closest('[data-cfa-card-options]').querySelector('[data-cfa-card-options-status]');
    status.textContent = `${option.dataset.variantLabel} selected. Open Quick Buy to complete your choices.`;
  });
})();

